export default {
    list: {
        title: 'Profile list',
        searchBox: {
            placeholder: 'Search',
        },
    },
    button: {
        create: 'Create',
    },
    form: {
        title: {
            create: 'Create profile',
            update: 'Update profile',
        },
        buttons: {
            save: 'Save',
        },
        labels: {
            name: 'Profile name',
            description: 'Description',
            default: 'By default',
            permissions: 'Permission list',
        },
        errors: {
            required: {
                permissions: 'Permissions is required',
            },
        },
        confirm: {
            message: 'Are you sure you want to delete this profile?',
            title: 'Delete profile',
        },
        placeholder: {
            name: 'Enter profile name',
            description: 'Enter description',
        },
    },
    create: {
        success: 'Create profile successfully',
    },
    update: {
        success: 'Update profile successfully',
    },
    delete: {
        success: 'Delete profile successfully',
    },
    tooltip: {
        defaultSelect: 'Default select',
    },
};
